import { render, staticRenderFns } from "./JobOfferDocument.vue?vue&type=template&id=dd708b80"
import script from "./JobOfferDocument.vue?vue&type=script&lang=js"
export * from "./JobOfferDocument.vue?vue&type=script&lang=js"
import style0 from "./JobOfferDocument.vue?vue&type=style&index=0&id=dd708b80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports